// extracted by mini-css-extract-plugin
export var customBtns = "mapWrapper-module--customBtns--f6e30";
export var customBtnsWrapper = "mapWrapper-module--customBtnsWrapper--7ccb3";
export var wrapper = "mapWrapper-module--wrapper--a8ccb";